import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'

import PencilRuler from '../../Icons/realestateinvestor/pencilruler.svg'
import Rocket from '../../Icons/realestateinvestor/rocket.svg'
import LightBox from '../../Icons/realestateinvestor/lightbox.svg'

export default function OurExpertise() {
    const WhyDM = [
        {
            icon: PencilRuler,
            title: 'Personalized to Perfection',
            desc: 'Each campaign is meticulously crafted to engage your unique audience.',
        },
        {
            icon: Rocket,
            title: 'Data-Driven Excellence',
            desc: 'Harness the power of data analytics for pinpoint accuracy in your campaigns.',
        },
        {
            icon: LightBox,
            title: 'Technological Edge',
            desc: 'Join the 56% of marketers embracing direct mail automation for efficient, impactful campaigns.',
        },
    ]
    const settings = {
        arrows: false,
        dots: true,
        className: 'align-items-center',
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 5000,
        appendDots: (dots) => {
            return <ul style={{ margin: '0px' }}> {dots}</ul>
        },
        customPaging: () => <span className="slick-dot"></span>,
    }
    return (
        <div className="bg-gradient-to-b from-[#fdedce] via-transparent to-[#fdedce] my-16 py-28 md:rounded-[120px] rounded-[70px]">
            <div className="max-w-full w-[1200px] mx-auto">
                <div className="text-center space-y-5 px-10 pt-5">
                    <h3 className="font-bold text-3xl px-4 md:text-[55px] md:leading-[64px]">
                        <span>Our </span>
                        <span className="olm-gradient-text">Expertise</span>
                        <span> at</span>
                        <br className="block md:hidden" />
                        <span> Your Disposal</span>
                    </h3>
                    <p className="text-lg md:text-[22px] font-semibold">
                        Custom Campaign Design
                    </p>
                    <div className="hidden md:flex flex-row md:flex-nowrap flex-wrap w-full md:space-x-4 md:space-y-0 space-y-4">
                        {WhyDM.map((why, i) => {
                            const Icon = why.icon
                            return (
                                <div
                                    className="md:w-1/3 w-full bg-olm-gradient-t-to-b p-[1px] rounded-[20px] shadow-[0_4px_20px_rgba(242,130,48,0.2)]"
                                    key={i}>
                                    <div className="h-full flex flex-col items-center justify-center bg-white md:py-20 py-12 md:px-10 px-4 space-y-4 rounded-[20px]">
                                        <div className="my-5">
                                            <Icon />
                                        </div>
                                        <h3 className="font-bold text-[25px] leading-7">
                                            {why.title}
                                        </h3>
                                        <p className="md:text-xl text-lg leading-[25px] text-[#444241]">
                                            {why.desc}
                                        </p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div className="block md:hidden">
                        <Slider {...settings}>
                            {WhyDM.map((why, i) => {
                                const Icon = why.icon
                                return (
                                    <div className="p-3" key={i}>
                                        <div className="bg-olm-gradient-t-to-b p-[1px] rounded-[20px] shadow-[0_4px_20px_rgba(242,130,48,0.2)]">
                                            <div className="h-full flex flex-col items-center justify-center bg-white md:py-20 py-12 md:px-10 px-4 space-y-4 rounded-[20px]">
                                                <div className="my-5">
                                                    <Icon />
                                                </div>
                                                <h3 className="font-bold text-[25px] leading-7">
                                                    {why.title}
                                                </h3>
                                                <p className="md:text-xl text-lg leading-[25px]">
                                                    {why.desc}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </Slider>
                    </div>
                    <a
                        className="sm:w-[25rem] max-w-full hidden md:inline-block"
                        href="#claimSwitch15">
                        <button className="md:w-[25rem] max-w-full font-semibold olm-gradient px-10 py-5 rounded shadow text-center text-[#fffbf9] text-[20px] leading-[23.48px] md:mt-[25px]">
                            Start With Direct Mail Today
                        </button>
                    </a>
                </div>
            </div>
        </div>
    )
}
